// extracted by mini-css-extract-plugin
export default {"successCard":"sucessCard_successCard__mATuE"};